module.exports = __webpack_public_path__ + "img/arrow4.14420e38.svg";